import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateSizingComponent } from './environment-sizing-documents/create-sizing/create-sizing.component';
import { PermissionUnauthorizedComponent } from '../permission-unauthorized/permission-unauthorized.component';

const routes: Routes = [
  {
   path: 'environment/:instanceId/sizing',
   component: CreateSizingComponent,
   title: 'Create Sizing'
 },
 {
   path: 'environment/:instanceId/sizing/:sizingDocumentId',
   component: CreateSizingComponent,
   title: 'Edit Sizing'
 },
 {
    path: 'environment/:instanceId/permission-unauthorized',
    component: PermissionUnauthorizedComponent,
    title: 'Permission Unauthorized'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EnvironmentDetailsRoutingModule { }
